<template>
	<div class="hn-votelist">
        <div v-if="familyList.length==0" class="votelist_notice">
            <van-image width="60%" height="60%" :src="require('@/assets/img/common/default.png')" @click="gotouch(item)"/>
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
        >
            <div  v-for="(item,key) in familyList" :key="key"  class="item_votelist_parent">
        		  <div class="item_votelist">
                  <div class="votelist_videos"  @click="canvass(item)">
                      <van-image width="3.02rem" height="2.04rem" :src="item.mediaurl[0]"/>
                      <div class="votelist_canvassing">
                        拉票
                      </div>
                  </div>
                  <div class="votelist_title">
                      <!-- <div class="votelist_id">NO.{{item.id}}</div> -->
                      <div class="votelist_cont">
                        <div class="votelist_name">{{item.name}}</div>
                        <div class="votelist_votes">{{item.voted}} 票</div>
                      </div>
                  </div>

              </div>
              <div class="votelist_footer">
                <div class="look" @click="canvass(item)">查看相册</div>
                <div v-if="item.isvote" class="vote">
                  已投
                </div>
                <div v-else class="vote" @click="go(item)">
                  投票
                </div>
              </div>
            </div>
        </van-list>
	</div>
</template>
<script>
    import './index.less'
    import { Image, List} from 'vant';
    export default {
        name:"VoteList",
        data() {
            return {
                mediaurl: '',
                imgurl:'',
                familyList:[],
                loading: false,
                finished: false,
                page:1
            }
        },
        components: {
            vanImage:Image,
            vanList:List
        },
        props: {
            keyword: {
              type: String,
              default: ''
            },
          itemid: {
            type: String,
            default: ''
          },
          sportsid: {
            type: String,
            default: ''
          }
        },
        watch: {
            keyword: function (val) {
              this.keyword = val
              this.familyList = []
              this.page = 1
              this.finished   =   false
              // this.getFamilyList()
            }
        },
        methods: {
            go:function (row) {
                // console.log(val)
              this.$api.sports
                  .vote({
                    mcloud_sports_item_user_id: row.min_id,
                  })
                  .then((r) => {
                    this.familyList = []
                    this.page = 1
                    this.finished   =   false
                    // this.getFamilyList();
                  })
            },
            canvass(item){
              this.$router.push({
                name: 'bn_vote',
                params: {item_sub_id:this.itemid,sports_id:this.sportsid},
                query: { id: item.urid, uid:item.min_id},
              })
            },
            getFamilyList(){
                this.$api.bainian.getList({page:this.page,keywords:this.keyword,cpgid: this.itemid}).then((res)=>{
                    if(res.status*1===200){
                        let list = res.data.list;
                        let todayvote = res.data.today_vote
                        list.forEach((item) => {
                          item.isvote = false
                          if (todayvote.findIndex((element)=>element == item.urid) !== -1) {
                            item.isvote = true
                          }
                          item.mediaurl = JSON.parse(item.mediaurl)
                        })
                        this.familyList = this.familyList.concat(list)
                        if(res.data.page.pageCount*1>this.page){
                            this.page++
                        }else{
                            this.finished   =   true
                        }

                    }
                    this.loading = false;
                })
            },
            onLoad() {
                if(this.finished) return;
                this.getFamilyList();
            }
        },
        mounted(){
            this.$nextTick(()=>{
                // this.getFamilyList();
            })
        }
    }
</script>
